import Vue from 'vue';
import PageLayout from '../components/pageLayout';

export default function() {
  Vue.component('PageLayout', PageLayout);
}
